<template>
  <AppLayout>
    <template #prepend>
      <AppBar>
        <template #prepend>
          <v-app-bar-nav-icon variant="flat" @click="toggleNav()" />
          <UrlInputDialog />
        </template>

        <template #default>
          <v-app-bar-title />
        </template>
        <template #append>
          <ExportLogsButton />
          <ExportButton />
          <TaskLoader />
          <UserProfile />
        </template>
      </AppBar>
    </template>

    <template #default />
    <template #append />
  </AppLayout>
  <SideNavigation />
</template>

<script lang="ts" setup>
  // import composables
  import { useAppStore } from '@/store/app/appStore';
  // import components shared
  import AppLayout from '@/layouts/AppLayout/AppLayout.vue';
  import TaskLoader from '@/components/TaskLoader.vue';
  import AppBar from '@/layouts/private/components/AppBar.vue';
  import UrlInputDialog from '@/components/UrlInputDialog.vue';
  // import components
  import SideNavigation from '@/layouts/private/components/SideNavigation/SideNavigation.vue';
  import UserProfile from '@/layouts/private/components/UserProfile.vue';
  import ExportButton from '@/components/ExportButton.vue';
  import ExportLogsButton from '@/components/ExportLogsButton.vue';

  const appStore = useAppStore();

  function toggleNav() {
    if (appStore.isSubNavOpen) {
      appStore.isSubNavOpen = false;
      appStore.isNavOpen = true;
    } else {
      appStore.toggleNav();
    }
  }
</script>
